__turbopack_context__.v({
  "arrow": "header-module-scss-module__2FXaBa__arrow",
  "container": "header-module-scss-module__2FXaBa__container",
  "copyButton": "header-module-scss-module__2FXaBa__copyButton",
  "copyButtonWrapper": "header-module-scss-module__2FXaBa__copyButtonWrapper",
  "dropped": "header-module-scss-module__2FXaBa__dropped",
  "header": "header-module-scss-module__2FXaBa__header",
  "headerTitle": "header-module-scss-module__2FXaBa__headerTitle",
  "status": "header-module-scss-module__2FXaBa__status",
  "statusText": "header-module-scss-module__2FXaBa__statusText",
  "titleRow": "header-module-scss-module__2FXaBa__titleRow",
  "trancheNumber": "header-module-scss-module__2FXaBa__trancheNumber",
});
